var MarlinStoreModule = /** @class */ (function () {
    function MarlinStoreModule() {
    }
    return MarlinStoreModule;
}());
export { MarlinStoreModule };
